export default __webpack_public_path__ + "static/media/Screenshot_1.70a12384.png";